import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useUserViewedPolicyMessages = () => {
  const client = useClient();
  const queryClient = useQueryClient();

  const mutationFn = ({ policyId, userId }: { policyId: string; userId: string }) =>
    client.put(`user/${userId}/policy/${policyId}/viewed-messages`, {
      json: {},
    });

  const result = useMutation({
    mutationFn,
    onSuccess: (_, variables) => {
      // Invalidate any relevant queries or perform any other side effects
      queryClient.invalidateQueries({
        queryKey: ['policyMetadata', { policyId: variables.policyId }],
      });
    },
  });
  return { ...result, userViewedPolicyMessages: result.mutateAsync };
};
